import React from 'react'
import { Navigate } from 'react-router-dom'
import { UserAuth } from '../context/AuthContext'
export const AdminProtectedRoute = ({ children }) => {
  const {currentUser,logout} = UserAuth();
  let handleLogout = () => {
      logout();
    };
  if(JSON.stringify(currentUser) !== '{}'){
    if(currentUser != null){
      console.log(currentUser)
      if (currentUser.email !== "feng.xiao@pomona.edu" && currentUser!=="Feng.Xiao@pomona.edu" && currentUser.email !== "captest2023@gmail.com" && currentUser.email !== "junaid@techsembly.com" && currentUser.email !== "asyalyubavina03@gmail.com") {
          console.log(typeof currentUser.email)
          alert("You are not allowed to access this page.");
          handleLogout();
          return <Navigate to="/" />
      }
    }
    else return <Navigate to="/" />
  }
  return children
}
